import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { iconsConfig } from '../../pages/CustomersPage/helpers';
import PushLogo from '../../pages/CustomersPage/icons/Notification';
import { RootState } from '../../store/store';
import Sidebar from '../Sidebar/Sidebar';
import Snackbar from '../Snackbar/Snackbar';
import style from './MainLayout.module.css';

const MainLayout: React.FC = () => {
  const { jwtToken } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();

  const [activeComponent, setActiveComponent] =
    useState<keyof typeof iconsConfig>('customer');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    if (!jwtToken) {
      navigate('/');
    }
  }, [jwtToken, navigate]);

  useEffect(() => {
    // §FB37: шукаємо ПЕРШИЙ відомий сегмент (не останній) — детальні роути на кшталт
    // /company/:companyId мають підсвічувати свій розділ («Компанії») в сайдбарі.
    const match = location.pathname
      .split('/')
      .filter(Boolean)
      .find((segment) => segment in iconsConfig);
    if (match) {
      setActiveComponent(match as keyof typeof iconsConfig);
    }
    // Закриваємо мобільну шухляду при зміні сторінки.
    setIsSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className={style.customers}>
      <Sidebar
        setActiveComponent={setActiveComponent}
        activeComponent={activeComponent}
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
      />
      {isSidebarOpen && (
        <div
          className={style.overlay}
          onClick={() => setIsSidebarOpen(false)}
        />
      )}
      <div className={style.management_content}>
        <div className={style.management_header}>
          <div className={style.header_left}>
            <button
              type="button"
              className={style.hamburger}
              aria-label="Меню"
              onClick={() => setIsSidebarOpen(true)}
            >
              <span />
              <span />
              <span />
            </button>
            <h3 className={style.header_title}>
              {iconsConfig[activeComponent].label}
            </h3>
          </div>
          <button className={style.header_button}>
            <PushLogo fill="#596987" />
          </button>
        </div>
        <div className={style.management_active_component}>
          <Outlet />
        </div>
        {/* §FB38: ЄДИНИЙ глобальний Snackbar — тости видно на будь-якій сторінці/вкладці. */}
        <Snackbar />
      </div>
    </div>
  );
};

export default MainLayout;
